import {Component, ContentChild, Output, EventEmitter, OnInit, TemplateRef, Input} from '@angular/core';

@Component({
  selector: 'luci-popover',
  templateUrl: './luci-popover.component.html',
  styleUrls: ['./luci-popover.component.scss']
})
export class LuciPopoverComponent implements OnInit {

  @Input() isOpen = false;
  @Input() isForm = false;
  @Input() position = '';
  @Input() headline = '';
  @Input() description = '';
  @Input() placeholder = '';
  @Input() continue = '';
  @Input() cancel = '';
  @Input() isDynamicContent = false;
  // tslint:disable-next-line:no-output-native
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @ContentChild(TemplateRef) templateRef: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

  isPopupCancel() {
    this.isOpen = false;
    this.close.emit(false);
  }

  isContinue() {
    this.isOpen = false;
    this.close.emit(false);
  }

}
